const AboutHero = function () {
    const aboutHero = document.querySelector('#aboutHero');

    const randomWidth = (min, max) => {
        return Math.random() * (max - min) + min;
    }


    const resizeImages = (selectedImg, selectedImageIndex, allImages) => {
        // make the selected Img larger, then randomize the widths of each of the other images
        allImages.forEach((aboutImg, i) => {
            if (i !== selectedImageIndex) {
                let widthVal = (i == (selectedImageIndex - 1) || i == (selectedImageIndex + 1)) ? randomWidth(116, 120) : randomWidth(116, 180);
                aboutImg.querySelector('img').style.width = widthVal + 'px';
                aboutImg.querySelector('img').style.opacity = '0.5';
            }
        });
        selectedImg.querySelector('img').style.width = '276px';
        selectedImg.querySelector('img').style.opacity = '1';

    }

    const resetImages = (allImages) => {
        // make the selected Img larger, then randomize the widths of each of the other images
        allImages.forEach((aboutImg) => {
            aboutImg.querySelector('img').style.width = null;
            aboutImg.querySelector('img').style.opacity = null;
        });
    }

    
    if (aboutHero) {
        const viewport = document.body.getAttribute('class');
        const aboutImgs = aboutHero.querySelectorAll('.gallery-image-slide');
        if (aboutImgs) {
            if ( viewport.includes("desktop") ) {
                aboutImgs.forEach((aboutImg, i) => {
                    aboutImg.addEventListener('mouseenter', (e) => {
                        resizeImages(e.target, i, aboutImgs);
                    });
                    aboutImg.addEventListener('mouseleave', (e) => {
                        resetImages(aboutImgs);
                    });
                });
            }
        }
    }

    let aboutImageGallery = document.querySelectorAll('.section-about-image-gallery');
    aboutImageGallery.forEach(section => {
        section.parentElement.style.overflow = 'hidden';
    });
}

export default AboutHero;
